import {createGlobalStyle} from 'styled-components';
import {rootElement} from './config';

const Color = {
    PRIMARY_BLUE: 'var(--color-primary-blue)',
    PRIMARY_BLUE_HOVER: 'var(--color-primary-blue-hover)',
    PRIMARY_BLUE_ACTIVE: 'var(--color-primary-blue-active)',

    GRAY_BLUE: 'var(--color-gray-blue)',
    GRAY_BLUE_HOVER: 'var(--color-gray-blue-hover)',
    GRAY_BLUE_ACTIVE: 'var(--color-gray-blue-active)',

    PRIMARY_RED: 'var(--color-primary-red)',
    PRIMARY_RED_HOVER: 'var(--color-primary-red-hover)',
    PRIMARY_RED_ACTIVE: 'var(--color-primary-red-active)',

    WHITE: 'var(--color-white)',
    BLACK: 'var(--color-black)',

    TEXT_GRAY: 'var(--color-text-gray)',
    BLOCK_GRAY: 'var(--color-block-gray)',
    OVERLAY_GRAY: 'var(--color-overlay-gray)',

    ICON_GRAY: 'var(--color-icon-gray)',
    ICON_GRAY_HOVER: 'var(--color-icon-gray-hover)',
    ICON_GRAY_ACTIVE: 'var(--color-icon-gray-active)',
};

const GlobalColors = createGlobalStyle`
    ${rootElement} {
        --color-primary-blue: #303983;
        --color-primary-blue-hover: #244c8e;
        --color-primary-blue-active: #28338f;

        --color-gray-blue: #e6e7ed;
        --color-gray-blue-hover: #dedfe8;
        --color-gray-blue-active: #dcdeec;

        --color-primary-red: #ac0000;
        --color-primary-red-hover: #971616;
        --color-primary-red-active: #c00808;

        --color-white: #ffffff;
        --color-black: #383838;

        --color-text-gray: #999999;
        --color-block-gray: #f6f6f6;
        --color-overlay-gray: rgba(0, 0, 0, 0.2);

        --color-icon-gray: #afafaf;
        --color-icon-gray-hover: #c4c4c4;
        --color-icon-gray-active: #afafaf;
    }
`;

export {Color, GlobalColors};
